// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2_iZI","remarks":"styles_remarks__23g-C","hidden":"styles_hidden__36hHj","more":"styles_more__3Mx1E"};